@if(resumeData?.clientInfomationTabData(); as client) {
  <div class="resume-style animated fadeIn" style="width: calc(100% - 12px); margin: auto">

    <!-- ── Section 1: Client Information ── -->
    <div class="kite-section-card">
      <div class="kite-section-title flex-wrap gap-2">
        <div class="d-flex align-items-center gap-2">
          <span>Client Information</span>
          @if (client.last_updated_by) {
            <span class="audit-trail-header mb-0">
              <i class="fa fa-history me-1"></i>
              Last edited by <strong>{{ client.last_updated_by.user_name }}</strong> on {{ formatAuditDate(client.last_updated_by.updated_at) }}
            </span>
          }
        </div>
        <div class="section-title-actions d-flex align-items-center flex-wrap gap-3">
          <div class="d-flex align-items-center">
            <app-checkbox 
              label="Send email collection receipt?" 
              [externalValue]="resumeData.clientInfomationTabData()?.send_collection_receipt ?? false" 
              [isSwitch]="true"
              [preventAutoChange]="true"
              (checkboxChange)="toggleReceiptPreference($event)"
              id="send_collection_receipt_resume">
            </app-checkbox>
          </div>
          <div class="section-actions">
            @if (editClientMode()) {
              <app-button size="sm" title="Save changes" [loading]="loadingEditClient()" (click)="saveClient()">
                <i class="fa fa-save mr-1"></i>
                Save Changes
              </app-button>
              <app-button size="sm" variant="secondary" [disabled]="loadingEditClient()" title="Discard changes" (click)="editClientMode.set(false)">
                <i class="fa fa-times mr-1"></i>
                Cancel
              </app-button>
            } @else {
              <app-button size="sm" variant="blue-text" title="Edit client information" (click)="editClientMode.set(true)">
                <i class="fa fa-edit mr-1"></i> Edit
              </app-button>
            }
          </div>
        </div>
      </div>

      <div class="row g-2 mt-1" [formGroup]="clientForm">
        @if (editClientMode() && clientForm) {
          <div class="col-xl-4 col-md-12 mb-2">
            <label class="label">Full address</label>
            <app-address-autocomplete [formControl]="control('address')" [value]="control('address').value" (placeSelected)="onPlaceSelected($event)"></app-address-autocomplete>
          </div>
          <app-custom-input class="col-xl-2 col-md-3 mb-2" label="Suite, Unit, Floor" [control]="control('address2')"></app-custom-input>
          <app-custom-input class="col-xl-2 col-md-3 mb-2" label="City" [control]="control('city')"></app-custom-input>
          <app-custom-input class="col-xl-2 col-md-3 mb-2" label="County" [control]="control('county')"></app-custom-input>
          <app-custom-input class="col-xl-2 col-md-3 mb-2" label="State" [control]="control('state')"></app-custom-input>

          <app-custom-input class="col-xl-2 col-md-3 mb-2" label="Zip code" [control]="control('zip_code')"></app-custom-input>
          <app-custom-input class="col-xl-2 col-md-3 mb-2" label="Contact name" [control]="control('contact_name')"></app-custom-input>
          <app-custom-input class="col-xl-2 col-md-3 mb-2" label="Email" [control]="control('email')"></app-custom-input>
          <app-custom-input class="col-xl-2 col-md-3 mb-2" label="Phone" [control]="control('phone')" mask="000-000-0000"></app-custom-input>
          <app-custom-input class="col-xl-2 col-md-6 mb-2" label="Referrer name" [control]="control('referrer_name')"></app-custom-input>
          <div class="col-xl-2 col-md-6 mb-2">
            <app-select 
            [control]="control('business_type')" 
            [source]="businessTypes()" 
            label="Business type" 
            [loading]="loadingBusinessTypes()"
            placeholder="Select a business type">
            </app-select>
          </div>
        } @else {
          <app-read-only-field label="Full address" class="col-xl-4 col-md-12 mb-2" [value]="client.address | titlecase"></app-read-only-field>
          <app-read-only-field label="Suite, Unit, Floor" class="col-xl-2 col-md-3 mb-2" [value]="client.address2 | titlecase"></app-read-only-field>
          <app-read-only-field label="City" class="col-xl-2 col-md-3 mb-2" [value]="client.city | titlecase"></app-read-only-field>
          <app-read-only-field label="County" class="col-xl-2 col-md-3 mb-2" [value]="client.county | titlecase"></app-read-only-field>
          <app-read-only-field label="State" class="col-xl-2 col-md-3 mb-2" [value]="client.state | titlecase"></app-read-only-field>

          <app-read-only-field label="Zip code" class="col-xl-2 col-md-3 mb-2" [value]="client.zip_code | titlecase"></app-read-only-field>
          <app-read-only-field label="Contact name" class="col-xl-2 col-md-3 mb-2" [value]="client.contact_name | titlecase"></app-read-only-field>
          <app-read-only-field label="Email" class="col-xl-2 col-md-3 mb-2" [value]="client.email"></app-read-only-field>
          <app-read-only-field label="Phone" class="col-xl-2 col-md-3 mb-2" [value]="client.phone"></app-read-only-field>
          <app-read-only-field label="Referrer name" class="col-xl-2 col-md-6 mb-2" [value]="client.referrer_name | titlecase"></app-read-only-field>
          <app-read-only-field label="Business type" class="col-xl-2 col-md-6 mb-2" [value]="client.business_type | titlecase"></app-read-only-field>
        }
      </div>
    </div>
  
  @if (resumeData.clientInfomationTabData()?.project && !resumeData.clientInfomationTabData()?.eco_only; as project) {
    <!-- ── Section 2: Service Agreement ── -->
    <div class="kite-section-card">
      <div class="kite-section-title flex-wrap gap-2">
        <div class="d-flex align-items-center gap-2">
          <span>Service Agreement</span>
        </div>
        @if (resumeData.clientInfomationTabData()?.project?.last_updated_by; as sa_audit) {
          <span class="audit-trail-header mb-0">
            <i class="fa fa-history me-1"></i>
            Agreement edited by <strong>{{ sa_audit.user_name }}</strong> on {{ formatAuditDate(sa_audit.updated_at) }}
          </span>
        }
      </div>

      <div class="row g-2 mt-1">
        @if (masterAgreementData() || resumeData.clientInfomationTabData()?.project?.master_agreement) {
          <!-- Adendum Layout: 4 fields on Row 1, 2 fields on Row 2 -->
          <app-read-only-field label="Payment type" class="col-xl-3 col-md-3 mb-2" [value]="paymentTypeName() | titlecase"></app-read-only-field>
          <app-read-only-field label="Price" class="col-xl-3 col-md-3 mb-2" [value]="isPercentagePayment() ? (resumeData.clientInfomationTabData()?.project?.price + '%') : (resumeData.clientInfomationTabData()?.project?.price | currency)"></app-read-only-field>
          <app-read-only-field label="Gallons per week" class="col-xl-3 col-md-3 mb-2" [value]="resumeData.clientInfomationTabData()?.project?.gallons"></app-read-only-field>
          <app-read-only-field label="Container size" class="col-xl-3 col-md-3 mb-2" [value]="resumeData.clientInfomationTabData()?.project?.container_size"></app-read-only-field>
          <app-read-only-field label="Agreement type" class="col-xl-4 col-md-4 mb-2" [value]="agreementTypeName() | titlecase"></app-read-only-field>
          
          <!-- ── Master Agreement: enriched view (Addendum clients only) ─────── -->
          @if (masterAgreementData(); as ma) {
            <div class="col-xl-8 col-md-8 mb-2">
              <label class="label">Master agreement name</label>
              <div class="d-flex align-items-center flex-wrap gap-3" style="width: 100%; font-size: 0.875rem; line-height: 1.5; color: #000; background-color: #ecf3fd; border-radius: 8px; border: none; height: 38px; padding: 0 14px;">
                <!-- ID -->
                @if (ma.ident_GUI) {
                  <span
                    style="cursor: pointer; font-size: 12px;"
                    (click)="navigateToMaster()"
                    [ngbTooltip]="'Go to master: ' + ma.ident_GUI"
                    placement="top"
                    container="body">
                    <i class="fa fa-id-badge me-1" style="color:#3b6fd4;"></i>
                    <strong style="color:#3b6fd4;">{{ ma.ident_GUI }}</strong>
                  </span>
                }
                <!-- Name (clickable) -->
                <span
                  style="font-weight: 600; font-size: 14px; color: #3b6fd4; cursor: pointer; text-decoration: underline; text-decoration-style: dotted;"
                  (click)="navigateToMaster()"
                  [ngbTooltip]="'Open Master client resume'"
                  placement="top"
                  container="body">
                  {{ ma.name | titlecase }}
                </span>
                <!-- Date (pushed to the right) -->
                @if (ma.master_created_at) {
                  <span class="ms-auto" style="font-size: 12px; color: #6b7a99;">
                    <i class="fa fa-calendar-o me-1"></i>
                    SA created: {{ ma.master_created_at | date:'MMM d, y' }}
                  </span>
                }
              </div>
            </div>
          } @else {
            <!-- Fallback for legacy string -->
            <app-read-only-field label="Master agreement name" class="col-xl-8 col-md-8 mb-2" [value]="resumeData.clientInfomationTabData()?.project?.master_agreement | titlecase"></app-read-only-field>
          }
        } @else {
          <!-- Master / Single Layout: 5 fields on Row 1 (evenly spaced), Master Agreement field hidden -->
          <app-read-only-field label="Payment type" class="col-12 col-md mb-2" [value]="paymentTypeName() | titlecase"></app-read-only-field>
          <app-read-only-field label="Price" class="col-12 col-md mb-2" [value]="isPercentagePayment() ? (resumeData.clientInfomationTabData()?.project?.price + '%') : (resumeData.clientInfomationTabData()?.project?.price | currency)"></app-read-only-field>
          <app-read-only-field label="Gallons per week" class="col-12 col-md mb-2" [value]="resumeData.clientInfomationTabData()?.project?.gallons"></app-read-only-field>
          <app-read-only-field label="Container size" class="col-12 col-md mb-2" [value]="resumeData.clientInfomationTabData()?.project?.container_size"></app-read-only-field>
          <app-read-only-field label="Agreement type" class="col-12 col-md mb-2" [value]="agreementTypeName() | titlecase"></app-read-only-field>
        }

        <app-read-only-field label="Special requirements" class="col-xl-12 col-md-12 mb-2" [value]="resumeData.clientInfomationTabData()?.project?.special_requirements" [multiline]="true" [height]="'120px'" [align]="'left'"></app-read-only-field>

        <div class="bottom-btn-sec mt-3 w-100">
          <div class="bottom-btn-sec-left flex-wrap gap-2">
            @if (resumeData.contextModule() === 'eco' && client.active === 'x' && permissions.hasPermission('customers', 'create')) {
              <app-button 
                variant="primary" 
                type="button" 
                (onClick)="openCreateServiceAgreement()">
                Reactivate UCO service
              </app-button>
            }

            @if (isAgreementSent() && resumeData.clientInfomationTabData()?.project?.agreement){
              <app-button 
              *appHasPermission="['customers', 'manageServiceAgreement']"
              [disabled]="loadingServiceAgreement()" 
              type="button" 
              [variant]="'red-text'"
              (onClick)="cancelAgreement()"
              ngbTooltip="Stop the existing signing request for this Services Agreement." 
              placement="top"
              container="body"
              [loading]="loadingServiceAgreement()">
                <i class="pr-2 fa fa-undo" aria-hidden="true"></i>
                Recall Singnature Request
              </app-button>
            }

            @if (isCanceledClient() && resumeData.clientInfomationTabData()?.project?.agreement){
              <app-button 
              variant="blue-text"
              *appHasPermission="['customers', 'manageServiceAgreement']"
              [disabled]="loadingServiceAgreement()" 
              type="button" 
              (onClick)="recreateAgreement()" 
              ngbTooltip="Send a new Signature request" 
              placement="top"
              container="body"
              [loading]="loadingServiceAgreement()"
              >
                <i class="pr-2 fa fa-refresh" aria-hidden="true"></i>
                Renew Agreement
              </app-button>
            }

            @if (canFinalizeAgreementLocally() && resumeData.clientInfomationTabData()?.project?.agreement){
              <app-button
              variant="primary"
              *appHasPermission="['customers', 'manageServiceAgreement']"
              [disabled]="loadingServiceAgreement()" 
              type="button" 
              (onClick)="captureLocalSignature()"
              ngbTooltip="Sign the agreement in person, without using Zoho."
              placement="top"
              container="body"
              [loading]="loadingServiceAgreement()">
                <i class="pr-2 fas fa-pencil-alt" aria-hidden="true" style="color: #ffffff !important;"></i>
                Capture Local Signature
              </app-button>

              <app-button
              variant="secondary"
              *appHasPermission="['customers', 'manageServiceAgreement']"
              [disabled]="loadingServiceAgreement()" 
              type="button" 
              (onClick)="openUploadSignedPDFModal()"
              ngbTooltip="Upload a manually signed PDF to finalize the agreement."
              placement="top"
              container="body">
                <i class="pr-2 fa fa-upload" aria-hidden="true"></i>
                Upload Signed PDF
              </app-button>
            }

          </div>

          <div class="bottom-btn-sec-right d-flex justify-content-end gap-2 flex-wrap">
            @if (resumeData.clientInfomationTabData()?.status !== CustomerTypesEnum.Prospect || isCanceledClient()){
              <app-button 
              variant="secondary" 
              *appHasPermission="['customers', 'editServiceAgreement']" 
              type="button" 
              [extraClasses]="'edit-service-agreement-btn'"
              (onClick)="openUpdateServiceAgreement()">
                Edit Services Agreement
              </app-button>
            }

            @if (resumeData.clientInfomationTabData()?.status !== CustomerTypesEnum.Prospect){
              <app-button 
              variant="secondary"
              type="button" 
              [loading]="loadingServiceAgreement()"
              (onClick)="getPDF()">
                <i class="pr-2 fa fa-file-pdf-o" aria-hidden="true"></i>
                View Services Agreement
              </app-button>
            }
          </div>
        </div>
      </div>
    </div>
  } @else {
    <!-- ── Empty State: No Service Agreement ── -->
    <div class="kite-section-card">
      <div class="kite-section-title">
        <span>Service Agreement</span>
      </div>

      <div class="grid grid-cols-12 gap-3 mt-1">
        <app-read-only-field label="Agreement type" class="col-span-4 mb-2" [value]="agreementTypeName() | titlecase"></app-read-only-field>
        <app-read-only-field label="Master agreement name" class="col-span-8 mb-2" [value]="resumeData.clientInfomationTabData()?.ucoMasterAgreement?.name | titlecase"></app-read-only-field>
      </div>

      <div class="mt-3 p-5 rounded-xl" style="background-color: #ecf3fd">
        <div class="text-center mx-auto">
          <i class="fa fa-exclamation-triangle fa-2x"></i>
          <div class="mt-2">
            <h5 class="mb-1 text-dark">This Client Doesn't Have a UCO Service Agreement</h5>
            <span class="text-muted">You can create one by clicking the button below.</span>
          </div>
          <app-button variant="primary" class="mt-4" type="button" (onClick)="openCreateServiceAgreement()">
            <i class="fa fa-plus mr-2" aria-hidden="true"></i> Create Agreement
          </app-button>
        </div>
      </div>
    </div>
  }
</div>
 
}
@else {
  <app-page-loading [absolute]="true"></app-page-loading>
}
